// Core
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

// Styles
import "./styles.scss";

// Redux
import { fetchNotifications } from "../../Redux/Slices/Common/notificationSlice";

// Custom components
import Drawer from "Components/Drawer";
import Navbar from "Components/Navbar";

const MainLayout = ({ children, style }) => {
  const location = useLocation(); // Get the current route
  const dispatch = useDispatch();

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const role = userDetails?.role;

  const isDashboardRoute =
    role !== 4 &&
    (location.pathname === "/" || location.pathname === "/settings");

  // Check if the current path matches the specific route
  const isAssessmentReview =
    location.pathname === "/assessment-review/view-assessment" ||
    location.pathname === "/pre-assessment/questions";
  useEffect(() => {
    dispatch(fetchNotifications({ page: 1, limit: 5 }));
  }, [dispatch]);

  return (
    <div className="main-layout">
      <div className="main-layout-header">
        <div className="main-layout-header-nav">
          <Navbar />
        </div>
      </div>
      <div className="main-layout-content">
        <Drawer />
        <div
          className={`main-layout-body-content ${
            isAssessmentReview ? "no-padding" : ""
          } ${isDashboardRoute ? "white-bg" : ""}`}
          style={style}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
